jQuery(document).ready(function($) {
	if ($('body').hasClass('single-shows')) {
		$( ".nav-shows" ).addClass( "current-menu-item" );
	}
});